import { SVGProps } from "react";

export const DotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="28" height="6" viewBox="0 0 28 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3Z" fill="currentColor"/>
    <path d="M17 3C17 4.65685 15.6569 6 14 6C12.3431 6 11 4.65685 11 3C11 1.34315 12.3431 0 14 0C15.6569 0 17 1.34315 17 3Z" fill="currentColor"/>
    <path d="M28 3C28 4.65685 26.6569 6 25 6C23.3431 6 22 4.65685 22 3C22 1.34315 23.3431 0 25 0C26.6569 0 28 1.34315 28 3Z" fill="currentColor"/>
  </svg>
);
